<template>
  <Form
    ref="formValidate"
    :model="formValidate"
    :rules="ruleValidate"
    :label-width="80"
    class="edit-win"
  >
    <FormItem label="原密码" prop="password">
      <Input type="password" v-model="formValidate.password" placeholder="请输入您的原密码"/>
    </FormItem>
    <FormItem label="新密码" prop="newPassword">
      <Input type="password" v-model="formValidate.newPassword" placeholder="请输入您的新密码"/>
    </FormItem>
    <FormItem label="确认密码" prop="qrPassword">
      <Input type="password" v-model="formValidate.qrPassword" placeholder="请再次输入您的新密码"/>
    </FormItem>
    <FormItem>
      <Button @click="submitInfo" type="primary">确定</Button>
      <!-- <Button @click="$router.go(-1)" style="margin-left: 8px">返回</Button> -->
    </FormItem>
  </Form>
</template>

<script>
export default {
  data() {
    return {
      formValidate: {
        password: '',         //密码
        newPassword: '',    //新密码
        qrPassword:''      
      },
      ruleValidate: {
        password: [
          { required: true, message: '原密码不能为空', trigger: 'blur' }
        ],
        newPassword: [
          { required: true, message: '新密码不能为空', trigger: 'blur' }
        ],
        qrPassword: [
          { required: true, message: '确认密码不能为空', trigger: 'blur' }
        ],
      }
    }
  },
  mounted() {

  },
  methods: {
    submitInfo() {
      if (this.formValidate.password == '') {
        this.tips('请先输入原密码')
      } else if (this.formValidate.newPassword == '') {
        this.tips('请先输入新密码')
      }else if (this.formValidate.newPassword != this.formValidate.qrPassword) {
        this.tips('新密码两次输入不一致')
      }else {
        this.$axios.post('/sys/user/password', this.formValidate)
          .then(function (response) {
            if (response.data.success) {
              this.$Message.success(response.data.data)
              this.$Loading.finish()
              this.tips('修改成功')
              // this.$router.go(-1)
            } else {
              this.$Message.error(response.data.errMsg)
              this.$Loading.error()
            }
          }.bind(this))
      }
     
    },
    tips(title) {
      this.$Modal.warning({
        title: title
      });
    },
  }
}
</script>




// WEBPACK FOOTER //
// src/views/user/password.vue